/// <reference types="vite/client" />
import * as ex from "excalibur";
import { GameScene } from "./scenes/GameScene";
import { landscapeImage } from "./graphics/LandscapeAtlas";
import { buildingsImage } from "./graphics/BuildingAtlas";
import { mountUserInfoModal } from "./ui/UserInfoModal";
import { mountAddCompanyButton } from "./ui/AddCompanyModal";
import { mountAccessibilityControls } from "./ui/AccessibilityControls";
import { mountDebugPanel } from "./ui/DebugPanel";
import { ensureNotificationPermissionForCurrentPreferences } from "./push";
class AutoLoader extends ex.Loader {
    onUserAction() {
        // hidePlayButton initializes _playButtonRootElement, which dispose() expects to exist
        this.hidePlayButton();
        return Promise.resolve();
    }
}
export async function startGame(user) {
    document.body.className = "overflow-hidden";
    const engine = new ex.Engine({
        displayMode: ex.DisplayMode.FillScreen,
        backgroundColor: ex.Color.fromHex("#8AB548"),
        antialiasing: false,
        pixelRatio: window.devicePixelRatio,
        maxFps: 60,
        snapToPixel: true,
        uvPadding: 0.5,
    });
    const gameScene = new GameScene(user, false);
    engine.add("game", gameScene);
    const loader = new AutoLoader([landscapeImage, buildingsImage]);
    void engine.start(loader).then(() => {
        void engine.goToScene("game");
    });
    void mountUserInfoModal(user);
    mountAddCompanyButton();
    void ensureNotificationPermissionForCurrentPreferences();
    mountAccessibilityControls({
        onPanChange: (dx, dy) => gameScene.setVirtualPan(dx, dy),
        onZoomChange: (dir) => gameScene.setVirtualZoom(dir),
    });
    if (import.meta.env.DEV ||
        import.meta.env.VITE_ENABLE_DEBUG_PANEL === "true") {
        void mountDebugPanel();
    }
}
export async function viewGroupMap(groupId, groupName) {
    document.body.className = "overflow-hidden";
    const engine = new ex.Engine({
        displayMode: ex.DisplayMode.FillScreen,
        backgroundColor: ex.Color.fromHex("#8AB548"),
        antialiasing: false,
        pixelRatio: window.devicePixelRatio,
        maxFps: 60,
        snapToPixel: true,
        uvPadding: 0.5,
    });
    const gameScene = new GameScene(undefined, true, `/api/sysadmin/groups/${groupId}/map/events`);
    engine.add("game", gameScene);
    const loader = new AutoLoader([landscapeImage, buildingsImage]);
    void engine.start(loader).then(() => {
        void engine.goToScene("game");
    });
    mountSysadminOverlay(groupName, () => {
        engine.stop();
        window.location.replace("/sysadmin");
    });
}
function mountSysadminOverlay(groupName, onBack) {
    const overlay = document.createElement("div");
    overlay.style.cssText = [
        "position:fixed",
        "top:0",
        "left:0",
        "right:0",
        "z-index:100",
        "display:flex",
        "align-items:center",
        "gap:12px",
        "padding:10px 16px",
        "background:rgba(0,0,0,0.55)",
        "backdrop-filter:blur(4px)",
        "font-family:sans-serif",
        "color:#fff",
    ].join(";");
    const label = document.createElement("span");
    label.style.cssText = "font-size:13px;opacity:0.8;";
    label.textContent = `Stadtansicht: ${groupName}`;
    const btn = document.createElement("button");
    btn.textContent = "← Zurück zum Dashboard";
    btn.style.cssText = [
        "padding:5px 14px",
        "font-size:13px",
        "border-radius:6px",
        "border:1px solid rgba(255,255,255,0.3)",
        "background:rgba(255,255,255,0.12)",
        "color:#fff",
    ].join(";");
    btn.addEventListener("click", onBack);
    overlay.appendChild(btn);
    overlay.appendChild(label);
    document.body.appendChild(overlay);
}
